import type {IABTestConfiguration} from "@pg-mono/ab-testing";
import {rpAppPath} from "@pg-mono/rp-routes";

import {OngoingABTests} from "./ongoing_ab_tests_enum";

export const PROPERTY_FAQ_LOGGED_IN_AB_TEST_ID = "rp-faq-login";
export const PROPERTY_FAQ_ANONYMOUS_AB_TEST_ID = "rp-faq-not-login";

/** No FAQ section at all — the base version of the property page */
export const PROPERTY_FAQ_LOGGED_IN_BASE_VARIANT = "faq_login_base" as const;
/** FAQ with answers available right away */
export const PROPERTY_FAQ_LOGGED_IN_OPEN_VARIANT = "faq_login_open" as const;

/** No FAQ section at all — the base version of the property page */
export const PROPERTY_FAQ_ANONYMOUS_BASE_VARIANT = "faq_not_login_base" as const;
/** FAQ with answers available without signing in */
export const PROPERTY_FAQ_ANONYMOUS_OPEN_VARIANT = "faq_not_login_open" as const;
/** FAQ with answers behind the registration gate */
export const PROPERTY_FAQ_ANONYMOUS_GATED_VARIANT = "faq_not_login_gated" as const;

/**
 * Two A/B tests managed by Amplitude Experiment — one for signed-in users, one for anonymous ones. The applicable
 * test is picked client side, from the auth state, so the FAQ stays out of SSR and out of the page cache key.
 * The Amplitude flags must expose the variants listed below.
 * Override in dev: ?ab_test_experiment=rp-faq-login&ab_test_variant=faq_login_open
 */
export const propertyFaqLoggedInAbTest: IABTestConfiguration = {
    id: PROPERTY_FAQ_LOGGED_IN_AB_TEST_ID,
    name: OngoingABTests.PROPERTY_FAQ_LOGGED_IN,
    expires: new Date(2027, 0, 1),
    path: [rpAppPath.property.detail.base],
    variants: [PROPERTY_FAQ_LOGGED_IN_BASE_VARIANT, PROPERTY_FAQ_LOGGED_IN_OPEN_VARIANT],
    withSSR: false,
    useAmplitude: true
};

export const propertyFaqAnonymousAbTest: IABTestConfiguration = {
    id: PROPERTY_FAQ_ANONYMOUS_AB_TEST_ID,
    name: OngoingABTests.PROPERTY_FAQ_ANONYMOUS,
    expires: new Date(2027, 0, 1),
    path: [rpAppPath.property.detail.base],
    variants: [PROPERTY_FAQ_ANONYMOUS_BASE_VARIANT, PROPERTY_FAQ_ANONYMOUS_OPEN_VARIANT, PROPERTY_FAQ_ANONYMOUS_GATED_VARIANT],
    withSSR: false,
    useAmplitude: true
};
import type {IABTestConfiguration} from "@pg-mono/ab-testing";
import {rpAppPath} from "@pg-mono/rp-routes";

import {OngoingABTests} from "./ongoing_ab_tests_enum";

export const PROPERTY_FAQ_LOGGED_IN_AB_TEST_ID = "rp-faq-login";
export const PROPERTY_FAQ_ANONYMOUS_AB_TEST_ID = "rp-faq-not-login";

/** No FAQ section at all — the base version of the property page */
export const PROPERTY_FAQ_LOGGED_IN_BASE_VARIANT = "faq_login_base" as const;
/** FAQ with answers available right away */
export const PROPERTY_FAQ_LOGGED_IN_OPEN_VARIANT = "faq_login_open" as const;

/** No FAQ section at all — the base version of the property page */
export const PROPERTY_FAQ_ANONYMOUS_BASE_VARIANT = "faq_not_login_base" as const;
/** FAQ with answers available without signing in */
export const PROPERTY_FAQ_ANONYMOUS_OPEN_VARIANT = "faq_not_login_open" as const;
/** FAQ with answers behind the registration gate */
export const PROPERTY_FAQ_ANONYMOUS_GATED_VARIANT = "faq_not_login_gated" as const;

/**
 * Two A/B tests managed by Amplitude Experiment — one for signed-in users, one for anonymous ones. The applicable
 * test is picked client side, from the auth state, so the FAQ stays out of SSR and out of the page cache key.
 * The Amplitude flags must expose the variants listed below.
 * Override in dev: ?ab_test_experiment=rp-faq-login&ab_test_variant=faq_login_open
 */
export const propertyFaqLoggedInAbTest: IABTestConfiguration = {
    id: PROPERTY_FAQ_LOGGED_IN_AB_TEST_ID,
    name: OngoingABTests.PROPERTY_FAQ_LOGGED_IN,
    expires: new Date(2027, 0, 1),
    path: [rpAppPath.property.detail.base],
    variants: [PROPERTY_FAQ_LOGGED_IN_BASE_VARIANT, PROPERTY_FAQ_LOGGED_IN_OPEN_VARIANT],
    withSSR: false,
    useAmplitude: true
};

export const propertyFaqAnonymousAbTest: IABTestConfiguration = {
    id: PROPERTY_FAQ_ANONYMOUS_AB_TEST_ID,
    name: OngoingABTests.PROPERTY_FAQ_ANONYMOUS,
    expires: new Date(2027, 0, 1),
    path: [rpAppPath.property.detail.base],
    variants: [PROPERTY_FAQ_ANONYMOUS_BASE_VARIANT, PROPERTY_FAQ_ANONYMOUS_OPEN_VARIANT, PROPERTY_FAQ_ANONYMOUS_GATED_VARIANT],
    withSSR: false,
    useAmplitude: true
};
